<div class="projects-routing__nav-container" [class.projects-routing__nav-container--fade-end]="showEndFade()">
  <div class="projects-routing__nav" #navScroll (scroll)="onNavScroll()">
    @if (visibleRoutes$ | async; as routes) {
      <div class="projects-routing__tab-nav">
        @for (item of routes; track item.url) {
          <button
            type="button"
            class="projects-routing__tab-item"
            [class.projects-routing__tab-item--active]="isActive(item)"
            (click)="onRouteClick(item)"
          >
            <div class="projects-routing__tab-icon">
              <mat-icon [svgIcon]="item.icon" />
            </div>
            <span class="projects-routing__tab-label">{{ item.display }}</span>
          </button>
        }
      </div>
    }
  </div>
</div>

<div
  class="projects-routing__content"
  [@swipe]="activeRouteIndex()"
  (@swipe.start)="onSwipeStart()"
  (@swipe.done)="onSwipeDone()"
>
  <ng-content />
</div>
